import api from '../api';

export const GetUrlAdvantagesClub = async () => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await api.get<{ Data: string }>('/v1/Cliente/getUrlAdvantagesClub/', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
